import React from 'react';
import { Map, List } from 'immutable';

const DeleteItemComponent = (() => (
  <>
    <i className="fa fa-trash" /> Delete
  </>
))();

/** Action delete. */
export const ACTION_DELETE = List([
  Map({
    key: 'delete',
    name: DeleteItemComponent,
  }),
]);
